import React, { useState } from 'react';
import { AlertData } from '../../../../components/alert/alert-view';
import DeactivationModal from '../deactivation-modal';
import { toggleModal } from '../../../../actions/app_action';
import { MODAL_NAMES, MODALS } from '../../../../constants';
import { useDispatch } from 'react-redux';

const useDeactivateLeasingOffers = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const closeAlert = () => {
    dispatch(toggleModal(MODALS.additional_dialog, null));
  };

  const openAlert = (alertData: AlertData) => {
    dispatch(toggleModal(MODALS.additional_dialog, MODAL_NAMES.additional_dialog, alertData));
  };

  const openDeactivationModal = (leasingOffersId: string[], clearCheckedLeasingOffers: () => void) => {
    const alertData: AlertData = {
      title: 'Archivierung bestätigen ',
      children: (
        <DeactivationModal
          leasingOffersId={leasingOffersId}
          clearCheckedLeasingOffers={clearCheckedLeasingOffers}
          setIsLoading={setIsLoading}
          closeAlert={closeAlert}
        />
      ),
      allButtonsHidden: true,
      buttons: [
        {
          type: 'cancel',
          title: 'Abbrechen',
          action: closeAlert
        }
      ]
    };

    openAlert(alertData);
  };

  return { openDeactivationModal, isLoading };
};

export default useDeactivateLeasingOffers;
